import { AppButton } from 'components';
import {
  AppModal,
  AppModalBody,
  AppModalFooter,
  AppModalHeader,
} from 'components/molecules/Modal/AppModal';
import useQuizQuestion from 'hooks/API/GET/useQuizQuestion';
import { Fragment } from 'react';
import { useParams } from 'react-router-dom';
import DOMPurify from 'dompurify';
import Editor from 'components/CKEditor/Editor';

function QuestionPreviewModal({ state = {}, closeModal }) {
  const { quizID, topicID } = useParams();
  const enabled = !!(quizID && topicID && state.questionID);

  const { data, isLoading, isError } = useQuizQuestion({
    enabled,
    quizID,
    topicID,
    questionID: state.questionID,
  });

  return (
    <AppModal open={state.show} closeModal={closeModal}>
      <AppModalHeader>{isLoading ? 'Please wait...' : 'Preview'}</AppModalHeader>
      <AppModalBody>
        {isLoading ? (
          'Loading...'
        ) : isError ? (
          'Failed to load data'
        ) : (
          <Fragment>
            <div className="row">
              <div className="col-3">Category:</div>
              <div className="col-9">{data?.data?.category}</div>
            </div>
            <hr />

            <div className="row">
              <div className="col-3">Question: </div>
              <div
                className="col-9"
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data?.data?.title) }}
              />
            </div>
            {data?.data?.options?.map?.((item, index) => {
              return (
                <div className="row" key={item?._id}>
                  <div className="col-3"></div>
                  <div className="col-9">
                    <Editor
                      heading={`Option ${index + 1}: `}
                      editorConfig={{
                        readOnly: true,
                        type: 'inline',
                        style: {
                          border: 'none',
                        },
                      }}
                      data={{
                        value: DOMPurify.sanitize(item.option),
                      }}
                    />
                  </div>
                </div>
              );
            })}

            <hr />
            <div className="row">
              <div className="col-3">Hint: </div>
              <div className="col-9">
                <Editor
                  editorConfig={{
                    readOnly: true,
                    type: 'inline',
                    style: {
                      border: 'none',
                    },
                  }}
                  data={{
                    value: DOMPurify.sanitize(data?.data?.hint),
                  }}
                />
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-3">Answer description: </div>
              <div className="col-9">
                <Editor
                  editorConfig={{
                    readOnly: true,
                    type: 'inline',
                    style: {
                      border: 'none',
                    },
                  }}
                  data={{
                    value: DOMPurify.sanitize(data?.data?.answerDescription),
                  }}
                />
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-3">Final answer: </div>
              <div className="col-9">
                <Editor
                  editorConfig={{
                    readOnly: true,
                    type: 'inline',
                    style: {
                      border: 'none',
                    },
                  }}
                  data={{
                    value: DOMPurify.sanitize(data?.data?.finalAnswer),
                  }}
                />
              </div>
            </div>
            <hr />
          </Fragment>
        )}
      </AppModalBody>
      <AppModalFooter>
        <AppButton variantClass="btn btn-danger mx-4" onClick={closeModal}>
          CLOSE
        </AppButton>
      </AppModalFooter>
    </AppModal>
  );
}

export default QuestionPreviewModal;
